import { DashboardCard, Flex, P, StyledContainer } from 'styling/GlobalStyles'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { IWidget } from 'types/dashboard.interface'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { WidgetEditOverlay } from 'pages/Dashboard/Dashboard.styled'
import { HrDashboardInnerWidgetContainer, } from '../HrDashboard.styled'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { useEffect, useState } from 'react'
import { getHrDashboardAiSuggestions } from 'features/hrDashboard/hr.slice'
import { SuggestionsModal } from './SuggestionsModal'
import { createPortal } from 'react-dom'

export const HrAISuggestionsWidget = ({
    modalOpen,
    removeWidget,
    onDragOver,
    onDragStart,
    onDragDrop
}: IWidget) => {

    const dispatch = useDispatch<AppDispatch>()
    const { aiSuggestions } = useSelector((store: RootState) => store.hrDashboard)
    const [modal, setModal] = useState(false)

    useEffect(() => {
        dispatch(getHrDashboardAiSuggestions({ page: 1, limit: 5 }))
    }, [])
    return (
        <DashboardCard
            draggable={modalOpen}
            onDragStartCapture={() => {
                onDragStart('suggestions', 2)
            }}
            onDrop={onDragDrop}
            onDragEnd={(e) => {
                e.preventDefault()
            }}
            onDragOver={(e) => {
                e.preventDefault()
                onDragOver('suggestions')
            }}
            width='1fr'
            style={{ gridArea: 'suggestions', cursor: modalOpen ? 'grab' : 'normal' }}
        >
            {modalOpen && (
                <WidgetEditOverlay
                    onClick={(e) => {
                        removeWidget('suggestions')
                        e.stopPropagation()
                    }}
                >
                    <P>Remove Widget</P>
                    <CloseIcon />
                </WidgetEditOverlay>
            )}
            <Flex width='100%' between >
                <TitleText weight='bold'>AI SUGGESTIONS</TitleText>

                {aiSuggestions?.totalCount > 5 && <OtherText onClick={() => setModal(true)} color='#ff9900' style={{ cursor: 'pointer' }} >View More</OtherText>}
            </Flex>
            <HrDashboardInnerWidgetContainer padding='0' style={{ height: '100%' }} >
                <Flex width='100%' column height='100%' gap='0.75rem' >
                    {aiSuggestions.data.length ? aiSuggestions.data.map(s => <StyledContainer key={s.id} width='100%' height='auto' >
                        <BodyText>{s.suggestion}</BodyText>
                    </StyledContainer>) : <TitleText style={{ width: '100%', textAlign: 'center' }} >No Suggestions Yet</TitleText>}
                </Flex>

            </HrDashboardInnerWidgetContainer>
            {modal && createPortal(<SuggestionsModal closeModal={() => setModal(false)} />, document.body)}

        </DashboardCard>
    )
}
